'use client';

export { default } from './ScopedCssBaseline';
export { default as scopedCssBaselineClasses } from './scopedCssBaselineClasses';
export * from './scopedCssBaselineClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ScopedCssBaseline/index.js
// module id = 950
// module chunks = 25